import actions from './actions';
import { exportCommonFile } from "../../../../helpers/utilities";

const initState = {
    loader: false,
    customerGroupdetails: '',
    posSetup: '',
    posSetupUsers: '',
    error: '',
    posSetupUsersloader: false,
    cProduct: '',
    cProductloader: false,
    cProductError: ''
};

export default function salesSetupReducer(state = initState, action) {
    switch (action.type) {
        case actions.CUSTOMERGROUP_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.CUSTOMERGROUP_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                customerGroupdetails: action.payload,
            };
        }
        case actions.CUSTOMERGROUP_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }

        case actions.POS_SETUP_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.POS_SETUP_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                posSetup: action.payload,
            };
        }
        case actions.POS_SETUP_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }

        case actions.POS_SETUP_USERS_START: {
            return {
                ...state,
                posSetupUsersloader: true,
                posSetupUsers: '',
            };
        }
        case actions.POS_SETUP_USERS_SUCCESS: {
            return {
                ...state,
                posSetupUsersloader: false,
                posSetupUsers: action.payload,
            };
        }
        case actions.POS_SETUP_USERS_FAILURE: {
            return {
                ...state,
                posSetupUsersloader: false,
                error: action.message,
            };
        }
        case actions.CPRODUCT_DETAILS_START: {
            return {
                ...state,
                cProductloader: true,
            };
        }
        case actions.CPRODUCT_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                cProductloader: false,
                cProduct: action.payload,
            };
        }
        case actions.CPRODUCT_DETAILS_FAILURE: {
            return {
                ...state,
                cProductloader: false,
                cProductError: action.message,
            };
        }

        case actions.CLEAR_SALES_SETUP_DETAILS_START: {
            return {
                ...state,
            };
        }
        case actions.CLEAR_SALES_SETUP_DETAILS_SUCCESS: {
            return {
                ...state,
                loader: true
            };
        }
        default:
            return state;
    }
}